import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import Icon from '@material-ui/core/Icon';
import Alert from '@material-ui/lab/Alert';
import NumberFormat from 'react-number-format';
import { apiClient } from '@services/api';

const C = {
  bg:       '#0f1e35',
  card:     '#172B4D',
  hover:    '#1e3a5a',
  accent:   '#62DEC2',
  textSec:  '#8ba5c4',
  textMain: '#e8f0fb',
  btnDef:   '#2a4f72',
};

const ApproveDetail = (props) => {
  document.title = `Aprovação Gerencial - ${process.env.REACT_APP_NAME}`;

  const { presale_id } = useParams();
  const history = useHistory();

  const [presale, setPresale]         = useState(null);
  const [budgets, setBudgets]         = useState([]);
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState(null);
  const [managerForm, setManagerForm] = useState({ value: '', note: '' });
  const [actionLoading, setActionLoading] = useState(false);
  const [actionError, setActionError]     = useState(null);

  const showError = (msg) => {
    setActionError(msg);
    setTimeout(() => setActionError(null), 5000);
  };

  useEffect(() => {
    apiClient.httpInstance.get(`/presales/${presale_id}`)
      .then(r => {
        setPresale(r.data);
        setManagerForm(f => ({ ...f, value: r.data.approval_value || '' }));
        setLoading(false);
      })
      .catch(() => {
        setError('Orçamento não encontrado.');
        setLoading(false);
      });

    apiClient.httpInstance.get(`/presales/${presale_id}/budgets`)
      .then(r => setBudgets(r.data))
      .catch(() => {});
  }, [presale_id]);

  const typeLabel = (type, val) => {
    if (!type || !val) return '—';
    if (type === 'discount_pct')   return `Desconto de ${val}%`;
    if (type === 'discount_value') return `Desconto de R$ ${val}`;
    if (type === 'installment')    return `${val}x sem juros`;
    return val;
  };

  const handleApprove = () => {
    if (!managerForm.value && !presale?.approval_value) return;
    setActionLoading(true);
    apiClient.httpInstance
      .post(`/presales/${presale_id}/approval/approve`, {
        approval_manager_value: (managerForm.value || presale.approval_value).trim(),
        approval_manager_note:  managerForm.note.trim() || undefined,
      })
      .then(() => apiClient.httpInstance.post(`/presales/${presale_id}/approve`).catch(() => {}))
      .then(() => history.push('/admin/aprovacoes'))
      .catch(() => showError('Erro ao aprovar. Tente novamente.'))
      .finally(() => setActionLoading(false));
  };

  const handleRefuse = () => {
    setActionLoading(true);
    apiClient.httpInstance
      .post(`/presales/${presale_id}/approval/refuse`, {
        approval_manager_note: managerForm.note.trim() || undefined,
      })
      .then(() => apiClient.httpInstance.post(`/presales/${presale_id}/disapprove`).catch(() => {}))
      .then(() => history.push('/admin/aprovacoes'))
      .catch(() => showError('Erro ao recusar. Tente novamente.'))
      .finally(() => setActionLoading(false));
  };

  const inputStyle = {
    width: '100%', boxSizing: 'border-box',
    background: '#0f1e35', border: `1px solid ${C.hover}`,
    borderRadius: 8, padding: '10px 14px',
    color: C.textMain, fontSize: 14, outline: 'none',
  };

  const labelStyle = { color: C.textSec, fontSize: 12, display: 'block', marginBottom: 6 };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 300, color: C.textSec }}>
        Carregando...
      </div>
    );
  }

  if (error) {
    return (
      <div className="px-7 pt-6">
        <Alert variant="filled" severity="error">{error}</Alert>
      </div>
    );
  }

  const apSt  = presale?.approval_status;
  const apType = presale?.approval_type;
  const apVal  = presale?.approval_value;

  const statusBadge = {
    pending:  { text: '⏳ Aguardando',   bg: '#78350f', color: '#fde68a' },
    approved: { text: '✓ Aprovado',      bg: '#14532d', color: '#bbf7d0' },
    refused:  { text: '✗ Não aprovado',  bg: '#7f1d1d', color: '#fecaca' },
  };

  return (
    <div className="px-7 pt-6" style={{ maxWidth: 760, margin: '0 auto' }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <button
          onClick={() => history.push('/admin/aprovacoes')}
          style={{
            background: 'transparent', border: `1px solid ${C.hover}`,
            color: C.textSec, borderRadius: 8, padding: '6px 14px',
            cursor: 'pointer', fontSize: 13, display: 'flex', alignItems: 'center', gap: 6,
          }}
        >
          <Icon style={{ fontSize: 16 }}>arrow_back</Icon>
          Aprovações
        </button>
        <span style={{ color: C.textSec, fontSize: 18 }}>›</span>
        <span style={{ color: C.textMain, fontSize: 18, fontWeight: 700 }}>
          Aprovação Gerencial — {presale?.references}
        </span>
        {apSt && statusBadge[apSt] && (
          <span style={{
            background: statusBadge[apSt].bg, color: statusBadge[apSt].color,
            borderRadius: 20, padding: '3px 12px', fontSize: 12, fontWeight: 700,
          }}>
            {statusBadge[apSt].text}
          </span>
        )}
      </div>

      {actionError && (
        <Alert className="mb-4" variant="filled" severity="error">{actionError}</Alert>
      )}

      {/* Pedido do consultor */}
      <div style={{ background: C.card, borderRadius: 10, marginBottom: 16 }}>
        <div style={{ padding: '16px', fontSize: 16, color: C.accent, fontWeight: 700, borderBottom: `1px solid ${C.hover}`, display: 'flex', alignItems: 'center', gap: 8 }}>
          <Icon style={{ fontSize: 18 }}>admin_panel_settings</Icon>
          Pedido do consultor
        </div>
        <div style={{ padding: 16 }}>
          <div style={{ color: C.textSec, fontSize: 12, marginBottom: 6 }}>Condição solicitada</div>
          <div style={{ color: C.textMain, fontWeight: 700, fontSize: 18, marginBottom: presale?.approval_justify ? 12 : 0 }}>
            {typeLabel(apType, apVal)}
          </div>
          {presale?.approval_justify && (
            <div style={{ color: C.textSec, fontSize: 13, marginTop: 8 }}>
              <span style={{ fontWeight: 600 }}>Justificativa:</span> {presale.approval_justify}
            </div>
          )}
        </div>
      </div>

      {/* Informações do cliente e orçamento */}
      <div style={{ background: C.card, borderRadius: 10, marginBottom: 16 }}>
        <div style={{ padding: '16px', fontSize: 15, color: C.textMain, fontWeight: 600, borderBottom: `1px solid ${C.hover}` }}>
          Cliente e orçamento
        </div>
        <div style={{ padding: 16, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <div>
            <div style={{ color: C.textSec, fontSize: 12, marginBottom: 4 }}>Cliente</div>
            <div style={{ color: C.textMain, fontSize: 14, fontWeight: 600 }}>{presale?.name}</div>
            <div style={{ color: C.textSec, fontSize: 13 }}>{presale?.email}</div>
          </div>
          <div>
            <div style={{ color: C.textSec, fontSize: 12, marginBottom: 4 }}>Vendedor</div>
            <div style={{ color: C.textMain, fontSize: 14 }}>{presale?.seller_name}</div>
          </div>
          <div>
            <div style={{ color: C.textSec, fontSize: 12, marginBottom: 4 }}>Total do orçamento</div>
            <NumberFormat
              value={Number(presale?.total || 0)}
              displayType="text"
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale
              thousandSeparator="."
              prefix={`${process.env.REACT_APP_CURRENCY} `}
              renderText={(v) => <div style={{ color: C.textMain, fontSize: 16, fontWeight: 700 }}>{v}</div>}
            />
          </div>
          <div>
            <div style={{ color: C.textSec, fontSize: 12, marginBottom: 4 }}>Referência</div>
            <div style={{ color: C.textMain, fontSize: 14 }}>{presale?.references}</div>
          </div>
        </div>

        {/* Itens do orçamento */}
        {budgets.length > 0 && (
          <div style={{ borderTop: `1px solid ${C.hover}`, padding: '12px 16px' }}>
            <div style={{ color: C.textSec, fontSize: 12, marginBottom: 10 }}>Itens</div>
            {budgets.map((b, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: i < budgets.length - 1 ? `1px solid ${C.hover}` : 'none' }}>
                <div>
                  <div style={{ color: C.textMain, fontSize: 14 }}>{b.tour_name || b.transfer_name || b.combo_name || '—'}</div>
                  {b.tour_date && (
                    <div style={{ color: C.textSec, fontSize: 12 }}>
                      {new Date(`${b.tour_date}T00:00:00`).toLocaleDateString('pt-BR')}
                    </div>
                  )}
                </div>
                <NumberFormat
                  value={Number(b.total || 0)}
                  displayType="text"
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  thousandSeparator="."
                  prefix={`${process.env.REACT_APP_CURRENCY} `}
                  renderText={(v) => <span style={{ color: C.textSec, fontSize: 13 }}>{v}</span>}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Formulário de resposta — só mostra se pendente */}
      {apSt === 'pending' && (
        <div style={{ background: C.card, borderRadius: 10, marginBottom: 24 }}>
          <div style={{ padding: '16px', fontSize: 15, color: C.textMain, fontWeight: 600, borderBottom: `1px solid ${C.hover}` }}>
            Sua resposta
          </div>
          <div style={{ padding: 16 }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
              <div>
                <label style={labelStyle}>
                  Valor aprovado <span style={{ fontSize: 11 }}>(pode alterar)</span>
                </label>
                <input
                  type="text"
                  value={managerForm.value || apVal || ''}
                  onChange={e => setManagerForm(f => ({ ...f, value: e.target.value }))}
                  placeholder={apVal}
                  style={inputStyle}
                />
              </div>
              <div>
                <label style={labelStyle}>Nota interna (opcional)</label>
                <input
                  type="text"
                  value={managerForm.note}
                  onChange={e => setManagerForm(f => ({ ...f, note: e.target.value }))}
                  placeholder="Observação para o consultor..."
                  style={inputStyle}
                />
              </div>
            </div>

            <div style={{ display: 'flex', gap: 12 }}>
              <button
                onClick={handleRefuse}
                disabled={actionLoading}
                style={{
                  flex: 1, background: 'transparent', border: '1px solid #ef4444',
                  color: '#fca5a5', borderRadius: 10, padding: '13px 0',
                  cursor: actionLoading ? 'not-allowed' : 'pointer',
                  fontWeight: 700, fontSize: 15,
                }}
              >
                {actionLoading ? '...' : 'Não aprovar'}
              </button>
              <button
                onClick={handleApprove}
                disabled={actionLoading || !(managerForm.value || apVal)}
                style={{
                  flex: 2, background: '#14532d', border: '1px solid #22c55e',
                  color: '#bbf7d0', borderRadius: 10, padding: '13px 0',
                  cursor: actionLoading ? 'not-allowed' : 'pointer',
                  fontWeight: 700, fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                }}
              >
                <Icon style={{ fontSize: 18 }}>check_circle</Icon>
                {actionLoading ? 'Salvando...' : 'Aprovar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Resultado se já resolvido */}
      {apSt === 'approved' && (
        <div style={{ background: '#0d2e1a', border: '1px solid #22c55e', borderRadius: 10, padding: 20, marginBottom: 24 }}>
          <div style={{ color: '#bbf7d0', fontWeight: 700, fontSize: 16, marginBottom: 6 }}>
            🎉 Aprovado: {typeLabel(apType, presale?.approval_manager_value || apVal)}
          </div>
          {presale?.approval_manager_note && (
            <div style={{ color: '#86efac', fontSize: 13 }}>Nota: {presale.approval_manager_note}</div>
          )}
        </div>
      )}

      {apSt === 'refused' && (
        <div style={{ background: '#2d0d0d', border: '1px solid #ef4444', borderRadius: 10, padding: 20, marginBottom: 24 }}>
          <div style={{ color: '#fca5a5', fontWeight: 700, fontSize: 16, marginBottom: 6 }}>
            Não aprovado: {typeLabel(apType, apVal)}
          </div>
          {presale?.approval_manager_note && (
            <div style={{ color: '#f87171', fontSize: 13 }}>Motivo: {presale.approval_manager_note}</div>
          )}
        </div>
      )}

      {/* Link para o orçamento completo */}
      <div style={{ textAlign: 'right', marginBottom: 32 }}>
        <button
          onClick={() => history.push(`/admin/orcamentos/detalhe/${presale_id}`)}
          style={{
            background: 'transparent', border: `1px solid ${C.hover}`,
            color: C.textSec, borderRadius: 8, padding: '7px 16px',
            cursor: 'pointer', fontSize: 13,
          }}
        >
          Ver orçamento completo →
        </button>
      </div>

    </div>
  );
};

const mapStateToProps = (state) => ({ user: state.user });
export default connect(mapStateToProps)(ApproveDetail);
